// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".transparent-button:hover .arrow{color:#243c82;fill:#243c82;border-width:2px}.hover-button:hover{background-color:#243c82;color:#fff;transition-duration:.5s}.dark-mode .hover-button:hover{background-color:#fff;color:#282d37;transition-duration:.5s}.dark-mode .dark-button{transition-duration:.5s;border-width:1px;border-color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
